import { getOnlyNumbers } from './getOnlyNumbers';

export const mapUserPayloadToData = ({
	email,
	firstName,
	lastName,
	role,
	phone,
	occupation,
	clientId,
	partnerId,
}: any) => {
	const data = {
		login: email,
		email,
		firstName,
		lastName,
		phoneNumber: `+${getOnlyNumbers(phone)}`,
		occupation,
		role,
		sentTemporaryPasswordTo: 'EMAIL',
		partnerId,
	};

	if (clientId) {
	    // @ts-ignore
		data.clientId = clientId;
	}

	return data;
};
